import React, { Component } from 'react'
import doneIcon from '../../assets/done.png'
import deleteIcon from '../../assets/delete-icon.png'
import { connect } from 'react-redux'
import Fade from 'react-reveal/Fade';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditableText } from "@blueprintjs/core";

class Item extends Component {

    state = {
        updateText: false,
        inputText: this.props.text,
        urlName: this.props.urlName,
        oldText: this.props.text,
        numberPicker: false,
        showText: '',

    }

    constructor(props) {
        super(props);
        console.log(props)
        if (this.props.text.startsWith('..Numberpicker..')) {
            var res = this.props.text.substring(16);
            this.setState({
                numberPicker: true,
                showText: res
            })

            // UPDATE THE OTHER ONES; show only the other

        }

    }

    handleChange = (e) => {
        console.log(e)
        this.setState({
            "inputText": e
        });
        console.log("HEREITCOMES: ", this.state.inputText, this.state.oldText);
    }

    changeItem = () => {

        // CALL A FUNCTION TO UPDATE IT
        // this.props(updateItem(this.state, lastItem (or something, need to remember what to delete)))
    }

    updateItem = () => {
        this.editItem(this.state);
        this.props.updateItem(this.state);
        this.setState({
            oldText: this.state.inputText
        });

    }

    editItem = () => {

        let newUpdateText = !this.state.updateText
        this.setState({
            updateText: newUpdateText,
        })
    }

    deleteItem = () => {
        this.props.deleteItem(this.state);

        toast.error(({ closeToast }) => <div onClick={closeToast} className="toast__div">
            Deleted item.
            Do you wish to recover it?
        <button className="toast__button" onClick={this.recoverItem}>Yes</button>
        </div>, {
                position: toast.POSITION.BOTTOM_CENTER,
            });
    }

    recoverItem = () => {
        this.props.recoverItem(this.state);
        toast.info("Recovered item", {
            position: toast.POSITION.BOTTOM_CENTER,
        });
    }

    render() {


        return (
            <div>
                text

            </div>
        )
    }
}
// create projects property. project property of the state
const mapStateToProps = (state) => {
    return {

    }
}

const mapDispatchToProps = (dispatch) => {
    return {

    }
}
// connect dashboard componenet to redux store
export default connect(mapStateToProps, mapDispatchToProps)(Item)
